import { useMemo } from 'react';

import { useMediaQuery } from '~/hooks/useMediaQuery';
import { breakpoints } from '~/styles/media.css';

import type { LineProps as Props } from './SectionLines.types';

import { LineDesktop } from '../Line/LineDesktop';
import { LineMobile } from '../Line/LineMobile';
import { useSectionContext } from '../Section/Section.context';
import { LineContext } from './SectionLines.context';

export const SectionLines = () => {
  const { linesFieldArray } = useSectionContext();
  const { fields: lines } = linesFieldArray;

  return useMemo(() => lines.map((line, lineIndex) => <Line key={line.id} line={line} lineIndex={lineIndex} />), [lines]);
};

const Line = ({ line, lineIndex }: Props) => {
  const isMobile = useMediaQuery(breakpoints.medium);

  const { sectionIndex } = useSectionContext();
  const lineFieldName = `sections.${sectionIndex}.lines.${lineIndex}` as const;
  const context = useMemo(
    () => ({
      line,
      lineIndex,
      lineFieldName,
      isProductLine: line.type === 'entry' && line.productId !== null,
      isMobile,
    }),
    [line, lineFieldName, lineIndex, isMobile],
  );

  return <LineContext value={context}>{isMobile ? <LineMobile /> : <LineDesktop />}</LineContext>;
};
